export const Customer = 'com.rewardsinc.coredata.dto.CustomerDto';
export const ProductInstance = 'com.rewardsinc.coredata.dto.ProductInstanceDto';
export const Location = 'com.rewardsinc.coredata.dto.LocationDto';
export const User = 'com.rewardsinc.coredata.dto.UserDto';
export const Address = 'com.rewardsinc.coredata.dto.AddressDto';
export const PasswordUpdate = 'com.rewardsinc.coredata.shared.PasswordUpdate';


// WEBPACK FOOTER //
// ./src/services/core-data/types.js